import posthog from 'posthog-js';
import type { App } from 'vue';

export function createPostHog(key: string, host: string) {
  return {
    install(app: App) {
      posthog.init(key, {
        api_host: host,
        autocapture: true,
        capture_pageview: false, // We fire $pageview manually via router
        opt_out_capturing_by_default: true, // Honour cookie consent; opt-in on Accept
      });

      app.config.globalProperties.$posthog = posthog;
    },
  };
}

export function usePostHog() {
  return posthog;
}
